module.exports = __webpack_public_path__ + "img/com.aircare.electrolux.6af48593.webp";